<template>
  <div class="content">
    <div v-for="income in incomeList" :key="income.id" @click="toOrderDetail(income)" >
      <order-item :id="income.order_no" :time="income.created_at" :price="'+' + income.agent_amount + '元'"></order-item>
    </div>
  </div>
</template>
<script>
import { getIncomeDetail } from '@/http/api'
import orderItem from '@/components/order_item'
export default {
  data () {
    return {
      incomeList: []
    }
  },
  components: {
    'order-item': orderItem
  },
  methods: {
    toOrderDetail (income) {
      this.$router.push({
        name: 'Incomeorderdetails',
        params: {income: income}
      })
    },
    getIncomeDetail (id) {
      let data = {
        id: id,
        token: localStorage.token
      }
      getIncomeDetail(data).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.incomeList = res.data
          console.log(this.incomeList)
        }
      })
    }
  },
  mounted () {
    let id = this.$route.query.id
    this.getIncomeDetail(id)
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/incomeparticularsdetail/Incomeparticularsdetail.vue